import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import common namespace
import enCommon from './locales/en/common.json';
import jaCommon from './locales/ja/common.json';
import viCommon from './locales/vi/common.json';

// Import auth namespace
import enAuth from './locales/en/auth.json';
import jaAuth from './locales/ja/auth.json';
import viAuth from './locales/vi/auth.json';

// Import chat namespace
import enChat from './locales/en/chat.json';
import jaChat from './locales/ja/chat.json';
import viChat from './locales/vi/chat.json';

// Import admin namespace
import enAdmin from './locales/en/admin.json';
import jaAdmin from './locales/ja/admin.json';
import viAdmin from './locales/vi/admin.json';

// Import rag namespace
import enRag from './locales/en/rag.json';
import jaRag from './locales/ja/rag.json';
import viRag from './locales/vi/rag.json';

// Import settings namespace
import enSettings from './locales/en/settings.json';
import jaSettings from './locales/ja/settings.json';
import viSettings from './locales/vi/settings.json';

// Import logs namespace
import enLogs from './locales/en/logs.json';
import jaLogs from './locales/ja/logs.json';
import viLogs from './locales/vi/logs.json';

const DEFAULT_LANGUAGE = 'ja';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    chat: enChat,
    admin: enAdmin,
    rag: enRag,
    settings: enSettings,
    logs: enLogs,
  },
  ja: {
    common: jaCommon,
    auth: jaAuth,
    chat: jaChat,
    admin: jaAdmin,
    rag: jaRag,
    settings: jaSettings,
    logs: jaLogs,
  },
  vi: {
    common: viCommon,
    auth: viAuth,
    chat: viChat,
    admin: viAdmin,
    rag: viRag,
    settings: viSettings,
    logs: viLogs,
  },
};

// Initialize default language if not set
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', DEFAULT_LANGUAGE);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: ['en', 'ja', 'vi'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'chat', 'admin', 'rag', 'settings', 'logs'],
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

